import { Component, Inject, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { filter, map as lodashMap } from 'lodash';
import { map, startWith, switchMap } from 'rxjs/operators';
import { IDocLog } from 'src/app/shared/models/doc-log/doc-log';
import { IStudent } from '../../typings/interfaces/student.interface';
import { ApiService } from './../../services/api-service/api-service';
import { DateHelpers } from './../../services/date-helpers/date-helpers.service';
import { HistoryAllHelperService, IHistoryRecord } from './history-all-helpers.service';

// used to filter ETL from docLogs, same on Staging and Prod (JE)
const ETL_USER_ID = 'X4tyiuhAJ9p93fx';

export interface IHistoryModalData {
  student: IStudent;
}

@Component({
  selector: 'history-all-modal',
  template: require('./history-all-modal.component.html'),
  styles: [require('./history-all-modal.component.scss')],
  encapsulation: ViewEncapsulation.None,
})
export class HistoryAllModalComponent implements OnInit {
  // locals
  docLogs: IHistoryRecord[];
  schoolId: string;
  dataLoading: boolean;

  historyData;
  tableColumns: string[];

  totalItems = 0;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(
    public dialogRef: MatDialogRef<HistoryAllModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IHistoryModalData,
    public dateHelpers: DateHelpers,
    public apiService: ApiService,
    public historyAllHelpers: HistoryAllHelperService,
  ) {}

  public ngOnInit(): void {
    const { student } = this.data;

    // initial fetch pulls page 1 history records (JE)
    this.tableColumns = ['docLog', 'age'];
    this.schoolId = student.schoolId;
    this.dataLoading = true;

    // subscribe to paginator change
    this.paginator.page
      .pipe(
        startWith({}),
        switchMap(() => {
          return this.apiService.getPaginatedDocLogs(this.schoolId, {
            page: this.paginator.pageIndex + 1,
            limit: 10,
            where: JSON.stringify({
              'createdBy.userId': { $ne: ETL_USER_ID },
              studentId: student._id,
              historyType: { $ne: null },
            }),
          });
        }),
        map(data => {
          this.totalItems = data.items.total;
          return data.data;
        }),
      )
      .subscribe(data => {
        const filteredDocLogs = filter(data, (docLog: IDocLog) => {
          return docLog.studentId === student._id;
        });
        const formattedData: IHistoryRecord[] = lodashMap(filteredDocLogs, (docLog: IDocLog) => {
          return this.historyAllHelpers.constructHistoryRecord(docLog);
        });
        const filteredData = filter(formattedData, (historyItem: IHistoryRecord) => {
          return !!historyItem;
        });
        this.historyData = new MatTableDataSource(filteredData);
        this.dataLoading = false;
      });
  }

  public onCancel(): void {
    this.historyData = [];
    this.dialogRef.close();
  }

  public parseDate(createdAt: string): string {
    return this.dateHelpers.getFormattedMoment(createdAt, 'MMM DD, YYYY [\u2014] h:mm:ss a');
  }
}
